import React from "react";
import AiJobPost from "../../components/JobPost/AiJobPost";
import Topbar from "../../components/Recruiter/Topbar/Topbar";
const NewJobPost = () =>{
    return(
        <div className="radial-gradient-bg">
            <Topbar/>
            <AiJobPost/>
        </div>
    )
}
export default NewJobPost;